<template>
  <div id="nav-block">
    <Row type="flex" class="header">
      <!--            logo 部分 start -->
      <i-col span="5" class="logo-block">
        <div class="logo-wrapper" @click="gotoHome">
          <img class="logo" src="../../assets/img/indexLong.png" alt="logo" />
        </div>
        <div class="logo-title" @click="gotoHome">
          {{ $t("message.motelName") }}
        </div>
      </i-col>
      <!--            logo 部分 end -->

      <!--            导航栏部分 start -->
      <i-col span="17">
        <div class="nav">
          <ul
            class="nav-button-list web"
            v-show="!isMobileView && (isLogin || windowWidth > 960)"
          >
            <li class="nav-button-home">
              <router-link
                class="nav-button"
                :class="{ 'nav-button-selected': routePath === '/' }"
                to="/"
                >{{ $t("message.menuHome") }}</router-link
              >
            </li>
            <li>
              <router-link
                class="nav-button"
                :class="{
                  'nav-button-selected': routePath === '/accommodation',
                }"
                to="/accommodation"
                >{{ $t("message.accommodation") }}</router-link
              >
            </li>
            <li>
              <router-link
                class="nav-button"
                :class="{ 'nav-button-selected': routePath === '/location' }"
                to="/location"
                >{{ $t("message.location") }}</router-link
              >
            </li>
            <li>
              <router-link
                class="nav-button"
                :class="{ 'nav-button-selected': routePath === '/contactUs' }"
                to="/contactUs"
                >{{ $t("message.contactUs") }}</router-link
              >
            </li>
            <li>
              <a
                class="nav-button"
                target="_blank"
                rel="noopener noreferrer"
                href="https://hotels.cloudbeds.com/reservation/Uag5xF"
              >
                {{ $t("message.BookNow") }}
              </a>
            </li>
            <li v-if="isLogin">
              <router-link class="nav-button" :class="{'nav-button-selected': routePath === '/order'}" to="/order">
                {{$t('message.menuOrder')}}</router-link></li>

            <!-- <li><router-link class="nav-button" :class="{'nav-button-selected': routePath === '/Member'}" to="/Member">{{$t('message.menuMember')}}</router-link></li> -->
            <!-- <li><router-link class="nav-button" :class="{'nav-button-selected': routePath === '/Activity'}" to="/Activity">{{$t('message.menuActivity')}}</router-link></li>  -->
            <!-- <li v-if="isLogin"><router-link class="nav-button" :class="{'nav-button-selected': routePath === '/Me'}" to="/Me">{{$t('message.menuMe')}}</router-link></li> -->
            <li v-if="isLogin" @click="signOut">
              <!-- {{ userInfo.email || "--" }} -->
                
              <div class="nav-button">
                Sign Out（ {{ userInfo && userInfo.email }} ）
              </div>
            </li>
            <!-- <li v-else @click="showLoginModal"><a class="nav-button">{{$t('message.menuLogin')}}</a></li> -->
            <li v-else-if="!isMobileView" @click="showLoginModal">
              <a class="nav-button">{{ $t("message.menuMembership") }}</a>
            </li>
          </ul>
          <div class="menu-button-block" :class="{ menuShow: isShowMenu }">
            <div class="menu-button" @click="triggerMenu">
              <div class="line-bar"></div>
              <div class="line-bar"></div>
              <div class="line-bar"></div>
            </div>
            <div class="menu-title">{{ $t("message.motelName") }}</div>
          </div>
        </div>
      </i-col>
      <LoginModal
        :is-show-login="isShowLoginModal"
        @updateShowLoginModalStatus="setIsShowLoginModal"
      />

      <!--            导航栏部分 end -->

      <!--            语言切换部分 start -->
      <!-- <i-col span="3" offset="3" class="lang">
                <div class="language-block">
                    <div>
                        <m-icons class="lang-icon" type="global" size="20" color="#DBDBDA"></m-icons>
                    </div>
                    <div class="language-text">{{$t('message.lang_text')}}</div>

                    <div class="language-change">
                        <div class="language-wrapper" @click="changeLang('zh')">
                            <m-color-icons class="flag" type="zhongguo" size="25"></m-color-icons>
                            <div class="language-text">中文</div>
                        </div>
                        <div class="language-wrapper" @click="changeLang('en')">
                            <m-color-icons class="flag" type="icon_NZxinxilan" size="25"></m-color-icons>
                            <div class="language-text">English</div>
                        </div>
                    </div>
                </div>

            </i-col> -->

      <!--            语言切换部分 end -->

      <!--            移动端菜单 start -->
      <i-col span="24">
        <div :class="{ menuShow: isShowMenu }">
          <ul class="mobile-nav-button-list">
            <li @click="closeMobileMenu">
              <router-link
                class="nav-button"
                :class="{ 'nav-button-selected': routePath === '/' }"
                to="/"
                >{{ $t("message.menuHome") }}</router-link
              >
            </li>
            <li @click="closeMobileMenu">
              <router-link
                class="nav-button"
                :class="{
                  'nav-button-selected': routePath === '/accommodation',
                }"
                to="/accommodation"
                >{{ $t("message.accommodation") }}</router-link
              >
            </li>
            <li @click="closeMobileMenu">
              <router-link
                class="nav-button"
                :class="{ 'nav-button-selected': routePath === '/location' }"
                to="/location"
                >{{ $t("message.location") }}</router-link
              >
            </li>
            <li @click="closeMobileMenu">
              <router-link
                class="nav-button"
                :class="{ 'nav-button-selected': routePath === '/contactUs' }"
                to="/contactUs"
                >{{ $t("message.contactUs") }}</router-link
              >
            </li>
            <li @click="closeMobileMenu">
              <a
                class="nav-button"
                target="_blank"
                rel="noopener noreferrer"
                href="https://hotels.cloudbeds.com/reservation/Uag5xF"
              >
                {{ $t("message.BookNow") }}
              </a>
            </li>
            <li v-if="isLogin" @click="closeMobileMenu">
              <router-link class="nav-button" :class="{'nav-button-selected': routePath === '/order'}" to="/order">
                {{$t('message.menuOrder')}}</router-link></li>
            <li v-if="!isLogin" @click="showLoginModal">
              <a class="nav-button">{{ $t("message.menuMembership") }}</a>
            </li>
            <li v-if="isLogin" @click="signOut">
              <router-link
                class="nav-button"
                :class="{ 'nav-button-selected': routePath === '/Me' }"
                to="/"
                >Sign Out（ {{ userInfo && userInfo.email }} ）</router-link
              >
            </li>
          </ul>
        </div>
      </i-col>
      <!--            移动端菜单 end -->
    </Row>
  </div>
</template>

<script>
import mIcons from "@/components/m-icons/m-icons.vue";
import mColorIcons from "@/components/m-icons/m-color-icons.vue";
import { getLoginStatus, gotoPage, urlRequest } from "../../common/common";
import LoginModal from "../LoginModal/LoginModal";
import { mapMutations, mapState } from "vuex";

export default {
  name: "navigationTop",

  data() {
    return {
      windowWidth: typeof window !== "undefined" ? window.innerWidth : 0,
      // 是否展示登录对话框
      isShowLoginModal: false,
      // 移动端菜单是否显示
      isMenuShow: false,
      // 语言列表
      langs: {
        zh: "中文",
        en: "English",
      },
      // 路由地址，直接读取浏览器地址栏的内容
      routePath: this.$route.path,
      // 移动端菜单展示状态
      isShowMenu: false,
    };
  },

  created() {
    console.log("created..");
  },

  mounted() {
    console.log("mounted...");
    console.log("isLogin: ", this.isLogin);
    if (typeof window !== "undefined") {
      this.handleResize();
      window.addEventListener("resize", this.handleResize);
    }
    setTimeout(() => {
    this.routePath = this.$route.path; // 延迟更新 routePath
  }, 100); // 延迟 100 毫秒
  },

  watch: {
    $route: "routePathUpdate",
  },

  methods: {
    // 关闭移动端菜单
    closeMobileMenu() {
      this.isShowMenu = false;
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    // 移动端菜单展示或关闭
    triggerMenu() {
      this.isShowMenu = !this.isShowMenu;
    },

    // 使用vue route页面跳转时修改路由地址
    routePathUpdate() {
      console.log("navigation path prop: ", this.$route.path);
      this.routePath = this.$route.path;
    },

    // 展示登录对话框
    showLoginModal() {
      this.isShowLoginModal = true;
      console.log("isShowLoginModal: ", this.isShowLoginModal);
    },

    // 从LoginModal子组件传来的状态值进行修改
    setIsShowLoginModal(val) {
      this.isShowLoginModal = val;
    },
    signOut() {
      localStorage.removeItem("userInfo");
      localStorage.removeItem("token");
      this.closeMobileMenu()
      this.$store.commit("setLoginStatus", false); // 设置为未登录
    },
    // 语言切换
    changeLang(lang) {
      switch (lang) {
        case "zh":
        case "en":
          this.$i18n.locale = lang;
          localStorage.setItem("lang", lang);
          // 重新获取酒店信息
          urlRequest({
            url: this.api.getMotelInfo,
            method: "POST",
          }).then((res) => {
            // 写入缓存
            localStorage.setItem("motelInfo", JSON.stringify(res.data.message));
            // 页面刷新
            location.reload();
          });
          break;
      }
    },

    // 页面跳转
    gotoHome() {
      gotoPage({
        path: "/",
      });
    },
  },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.handleResize);
    }
  },
  computed: {
    ...mapState([
      // 是否登录状态
      "isLogin",
      "userInfo",
    ]),
    isMobileView() {
      return this.windowWidth <= 960; // 或者你设定的移动端断点
    },
    showLoginButton() {
      return !this.isLogin && this.windowWidth > 960;
    },
  },

  components: {
    LoginModal,
    // mIcons,
    // mColorIcons,
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/style/mainStyle.scss";
@import "NavigationTop.scss";
</style>
